var map = {
	"./about_icon (2).png": 1501,
	"./about_icon (3).png": 4182,
	"./about_icon (4).png": 8459,
	"./about_icon (5).png": 6036,
	"./about_icon (6).png": 2961,
	"./about_icon (7).png": 4506,
	"./about_icon (8).png": 3871,
	"./about_icon (9).png": 1464,
	"./about_icon.png": 2334
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8879;